/* unplugin-vue-components disabled */import script from "./GoodsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsTable.vue?vue&type=script&setup=true&lang=js"

import "./GoodsTable.vue?vue&type=style&index=0&id=1993d54e&lang=css"

const __exports__ = script;

export default __exports__